
import { dbManager } from './db_manager';

export const friendService = {
    async getFriendships(userId: string) {
        return dbManager.from('friendships', userId).select(
            { OR_USER_FRIEND: userId },
            undefined,
            'friendships'
        );
    },

    async sendRequest(userId: string, friendId: string) {
        return dbManager.from('friendships', userId).upsert({
            id: crypto.randomUUID(),
            user_id: userId,
            friend_id: friendId,
            status: 'pending',
            created_at: new Date().toISOString()
        });
    },

    async acceptRequest(friendshipId: string | null, userId: string, senderId?: string) {
        if (friendshipId) {
            return dbManager.from('friendships', userId).update(
                { status: 'accepted' },
                { id: friendshipId }
            );
        } else if (senderId) {
            return dbManager.from('friendships', userId).update(
                { status: 'accepted' },
                { user_id: senderId, friend_id: userId }
            );
        }
    },

    async removeFriend(friendshipId: string | null, userId: string, friendId?: string) {
        if (friendshipId) {
            try {
                await dbManager.from('friendships', userId).delete(friendshipId);
            } catch (err) {
                console.error("Error deleting friendship by id:", err);
            }
        }
        if (friendId) {
            try {
                await dbManager.from('friendships', userId).deleteMatch({
                    user_id: friendId,
                    friend_id: userId
                });
            } catch (err) {
                console.warn("deleteMatch direction 1 ignored/failed:", err);
            }
            try {
                await dbManager.from('friendships', userId).deleteMatch({
                    user_id: userId,
                    friend_id: friendId
                });
            } catch (err) {
                console.warn("deleteMatch direction 2 ignored/failed:", err);
            }
        }
    }
};
